import axios from "axios";
import { auth } from "./firebase";

const API_URL = process.env.REACT_APP_BACKEND_URL;

class AuthService {
  // constructor() {
  //   this.recaptchaVerifier = null;
  // }

  // Login user
  async login(email, password) {
    try {
      const response = await axios.post(`${API_URL}v2/signin`, {
        email,
        password,
      });
      if (response.data.token) {
        localStorage.setItem("auth_token", response.data.token);
      }
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  async forgotPassword(email) {
    const formData = new FormData();
    formData.append("applicant_email", email);
    try {
      const response = await axios.post(
        `${API_URL}v2/reset-password`,
        formData
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  async registerUser(studentData) {
    const response = await axios.post(`${API_URL}v2/signup`, {
      name: studentData.fullName,
      email: studentData.email,
      password: studentData.password,
      password_confirmation: studentData.confirmPassword,
      phone: studentData.phone,
      // phone_refrence_id: studentData.phoneStatus.referenceId,
      email_refrence_id: studentData.emailStatus.referenceId,
    });

    return response.data;
  }

    async updateUserProfile(studentData) {

    const token = localStorage.getItem("auth_token"); 

    const response = await axios.post(`${API_URL}v2/profile/update`, studentData,{
      headers: {
        Authorization: `Bearer ${token}`,
   
      }
    });

    return response.data;
  }

  async updateAcademic(studentData) {

        const token = localStorage.getItem("auth_token"); 

    const response = await axios.post(`${API_URL}v2/academic/update`, studentData,{
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });

    return response.data;
  }

  async getUser(dispatch) {
    const token = localStorage.getItem("auth_token");

    try {
      const response8 = await axios.get(
        "https://campus.acetians.in/api/v2/get-user",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


     
      dispatch({ type: "SET_STUDENT_DATA", payload: {...response8?.data?.user,
        ...response8?.data?.user?.profile_details} });
    } catch (error) {
      console.log("Get user failed:", error?.message || error);
    }
  }


  async getUser2() {
    const token = localStorage.getItem("auth_token");

    try {
      const response8 = await axios.get(
        "https://campus.acetians.in/api/v2/refresh-details",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      console.log("refrsh api",{
        ...response8?.data?.user,
        ...response8?.data?.user?.profile_details,
        profile_details:null
      })

      
    } catch (error) {
      console.log("Get user failed:", error?.message || error);
    }
  }

  async generateOTP(type_of, sender) {
    const response = await axios.post(`${API_URL}v2/send-otp`, {
      type_of,
      sender,
    });
    return response.data;
  }

  async validateOTP(type_of, studentData) {
    var payload = {};
    if (type_of === "email_otp") {
      payload = {
        sender: studentData.email,
        reference_id: studentData.emailStatus.referenceId,
        otp: studentData.emailStatus.otp,
      };
    } else {
      payload = {
        sender: studentData.phone,
        reference_id: studentData.phoneStatus.referenceId,
        otp: studentData.phoneStatus.otp,
      };
    }
    const response = await axios.post(`${API_URL}v2/validate-otp`, payload);

    return response.data;
  }

  async getLoggedInUser() {
    const token = localStorage.getItem("auth_token");

    if (!token) throw new Error("No auth token found");

    try {
      const response = await axios.get(`${API_URL}v2/get-user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {}
  }

  async completeProfile(studentStudentChalanDetailsData) {
    // console.log("".studentStudentChalanDetailsData);
    const token = localStorage.getItem("auth_token");

    const formData = new FormData();

    formData.append(
      "profile_photo",
      studentStudentChalanDetailsData.profile_photo
    );
    formData.append("gender", studentStudentChalanDetailsData.gender);
    formData.append("category", studentStudentChalanDetailsData.category);
    formData.append(
      "academic_level",
      studentStudentChalanDetailsData.academic_level
    );
    formData.append("same_state", studentStudentChalanDetailsData.same_state);

    formData.append(
      "admission_code",
      studentStudentChalanDetailsData.admission_code
    );
    formData.append("course_name", studentStudentChalanDetailsData.course_name);
    formData.append("course_year", studentStudentChalanDetailsData.course_year);
    formData.append(
      "refrence_roll",
      studentStudentChalanDetailsData.refrence_roll
    );
    const response = await axios.post(
      `${API_URL}v2/complete-profile`,

      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }

  async logoutUser() {
    const token = localStorage.getItem("auth_token");
    if (!token) return;

    localStorage.removeItem("auth_token");
    localStorage.removeItem("user");
  }

  isAuthenticated() {
    return !!localStorage.getItem("auth_token");
  }

  async fileUploads(name, file) {
    const token = localStorage.getItem("auth_token");

    const formData = new FormData();
    formData.append("document_link", file);
    formData.append("document_name", name);

    const response = await axios.post(
      `${API_URL}v2/upload-document`,

      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }

  // async initializeRecaptcha() {
  //   if (this.recaptchaVerifier) {
  //     return this.recaptchaVerifier;
  //   }

  //   this.recaptchaVerifier = new RecaptchaVerifier(
  //     auth,
  //     "recaptcha-container",
  //     {
  //       size: "invisible",
  //     }
  //   );

  //   await this.recaptchaVerifier.render();
  //   return this.recaptchaVerifier;
  // }

  // async getRecaptchaToken() {
  //   const verifier = await this.initializeRecaptcha();
  //   return await verifier.verify();
  // }

}

export default new AuthService();
